import { Components } from "@thisgorilla/primate-ds";

import { useTheme } from "styled-components";
import { FlexRow, FlexRowCenter } from "../../../../Common/Styles";

export const TitleAndButton = () => {
  const { typography } = useTheme();

  return (
    <FlexRow>
      <FlexRowCenter $gapInPx={8}>
        <Components.Icon type="Monitor" size="16px" />
        <Components.Text
          text={"Studio"}
          style={{ tokenStyle: typography.Heading.S }}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-400"
        />
        <Components.Counter
          color="Primary"
          count={"12"}
          kind="Fill"
          size="Small"
        />
      </FlexRowCenter>
    </FlexRow>
  );
};
